import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import $ from 'jquery';

var Config = require('../../config');

class TransfusionForm extends Component{
	constructor(props){
		super(props);

		this.handleClose = this.handleClose.bind(this);
		this.onSave = this.onSave.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.checkIncident = this.checkIncident.bind(this);

		this.state = {
			unit_id:"",

			start_type:"START",
			end_type:"END",
			during_type:'DURING',

			start_id:"",
			start_date:"",
			start_hour:"",
			start_medical_name:"",
			start_sistiolica:"",
			start_diastiolica:"",
			start_pulse:"",
			start_temperature:"",
			start_timestamp:"",

			during_id:"",
			during_date:"",
			during_hour:"",
			during_medical_name:"",
			during_sistiolica:"",
			during_diastiolica:"",
			during_pulse:"",
			during_temperature:"",
			during_timestamp:"",

			end_id:"",
			end_date:"",
			end_hour:"",
			end_medical_name:"",
			end_sistiolica:"",
			end_diastiolica:"",
			end_pulse:"",
			end_temperature:"",
			end_timestamp:"",

			start_incidents:[],
			during_incidents:[],
			end_incidents:[],
			valid_start:false,
			valid_end:false,
			valid_during:false,
			
			observations:"",
			incidents:[],
			incidents_list:[],
			list_incidents:[],
			incident_id:"",
			incident_type_id:"",
			method_incidents:'post',
			transfusional_id:"",
			incidents_type:[],
			check_incident:false,

			enable_during:false,
			enable_end:false,
			enable_start:false,
			incident_time:"",
			start_heart_rate:"",
			during_heart_rate:"",
			end_heart_rate:"",
		}
	}

	validInputDate(message, id){
		if(message !== ""){
			swal('Error', message, 'error');
			
			setTimeout(()=>{
				$('#'+id).val('')
					.attr('type', 'text')
					.attr('type', 'date');
			}, 4000);

			$('#'+id).addClass('error');
		}else{
			$('#'+id).removeClass('error');
		}
	}

	componentDidMount(){
		$(document).on('blur', '#start_date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});

		$(document).on('blur', '#during_date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});

		$(document).on('blur', '#end_date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});

		//this.props.onRef(this);
		this.setState({enable_start:true});
		fetch(Config.default.apiGateway.URL+'lookups_level2?type=transfusion_incident&option=parents',{
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					incidents_type:response
				});				
			}
		})

		fetch(Config.default.apiGateway.URL+'lookups_level2?type=transfusion_incident&option=children',{
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					list_incidents:response
				});				

				this.getValues();
			}
		})

	}

	getValues(){
		var id = this.props.match.params.id;
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'transfusional_control/?unit_id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					unit_id:id,
					hospital:response.hospital,
					patient:response.patient
				});
				if(response.transfusional.length > 0){
					this.setState({method:'put'});

					var incident = 0;
					response.transfusional.map((t)=>{


						if(t.control.type === 'START'){
							this.setState({
								start_id:t.control.id,
								start_date:moment(t.control.date).format('YYYY-MM-DD'),
								start_hour:moment(t.control.hour, 'H:mm:ss').format('HH:mm'),
								start_medical_name:t.control.medical_name,
								start_sistiolica:t.control.sistiolica,
								start_diastiolica:t.control.diastiolica,
								start_pulse:t.control.pulse,
								start_temperature:t.control.temperature,
								start_timestamp:t.control.timestamp,
								start_incidents: t.incidents,
								start_heart_rate: t.control.heart_rate
							})

							if(t.incidents.length > 0){
								incident++;
							}
						}

						if(t.control.type === 'DURING'){
							this.setState({
								during_id:t.control.id,
								during_date:moment(t.control.date).format('YYYY-MM-DD'),
								during_hour:moment(t.control.hour, 'H:mm:ss').format('HH:mm'),
								during_medical_name:t.control.medical_name,
								during_sistiolica:t.control.sistiolica,
								during_diastiolica:t.control.diastiolica,
								during_pulse:t.control.pulse,
								during_temperature:t.control.temperature,
								during_timestamp:t.control.timestamp,
								during_incidents: t.incidents,
								during_heart_rate: t.control.heart_rate
							})
							if(t.incidents.length > 0){
								incident++;
							}
						}

						if(t.control.type === 'END'){
							this.setState({
								end_id:t.control.id,
								end_date:moment(t.control.date).format('YYYY-MM-DD'),
								end_hour:moment(t.control.hour, 'H:mm:ss').format('HH:mm'),
								end_medical_name:t.control.medical_name,
								end_sistiolica:t.control.sistiolica,
								end_diastiolica:t.control.diastiolica,
								end_pulse:t.control.pulse,
								end_temperature:t.control.temperature,
								end_timestamp:t.control.timestamp,
								end_incidents: t.incidents,
								end_heart_rate: t.control.heart_rate
							})
						}



					})

					if(incident !== 0){
						this.setState({check_incident:true, incident_time:'START'});
						this.loadIncidents(this.state.start_incidents);
					}

				}else{
					this.setState({method:'post'});
					
				}
			}
		})
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
		});

		if(e.target.value !== ""){
			this.showInputError(e.target.name);
		}

		if(e.target.name === 'observations'){
			if(this.state.enable_start){
				if(this.state.start_incidents.length > 0){
					this.state.start_incidents[0].incident.observations = e.target.value;
					this.forceUpdate();
				}else{
					this.setState({
						start_incidents: [{incident:{observations:e.target.value}, detail:[]}]
					})
				}
				
			}

			if(this.state.enable_during){
				if(this.state.during_incidents.length > 0){
					this.state.during_incidents[0].incident.observations = e.target.value;
					this.forceUpdate();
				}else{
					this.setState({
						during_incidents: [{incident:{observations:e.target.value}, detail:[]}]
					})
				}
			}

			if(this.state.enable_end){
				if(this.state.end_incidents.length > 0){
					this.state.end_incidents[0].incident.observations = e.target.value;
					this.forceUpdate();
				}else{
					this.setState({
						end_incidents: [{incident:{observations:e.target.value}, detail:[]}]
					})
				}
			}
		}
	}

	handleClose(){
		this.props.history.push('/transfusional_control/list');
	}

	isValidForm() {
		//const select = document.querySelector('div.modal-body');
  		const inputs = document.querySelectorAll('input');
	    //const inputs = document.querySelectorAll('input');
	    let isFormValid = true;
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showInputError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	  
	    
	    return isFormValid;
	}

	showInputError(refName) {
		const control = document.getElementById(refName);
		
		if(control.value === ""){
			if(control !== null){
	            control.classList.add('error');
	        }
			return false;
		}else{
			if(control.className.includes('error')){
				control.classList.remove('error');
			}
			return true;
		}
	}

	onSave(e){
		this.saveType();
		var obj = [];
		var inc = {};
		setTimeout(()=>{
			if(this.state.valid_start){
				var start = {
					date: moment(this.state.start_date).format('YYYY-MM-DD') !== 'Invalid date' ?
						  	moment(this.state.start_date).format('YYYY-MM-DD') : "",
					hour: moment(this.state.start_hour, 'HH:mm').format('H:mm') !== 'Invalid date' ?
						 	moment(this.state.start_hour, 'HH:mm').format('H:mm') : "",
					medical_name: this.state.start_medical_name,
					sistiolica: this.state.start_sistiolica,
					diastiolica: this.state.start_diastiolica,
					pulse: this.state.start_pulse,
					temperature: this.state.start_temperature,
					unit_id:this.state.unit_id,
					type:this.state.start_type,
					heart_rate:this.state.start_heart_rate
				}

				if(this.state.start_id !== ""){
					start.id = this.state.start_id;
					start.timestamp = this.state.start_timestamp;
				}

				if(this.state.check_incident){
					inc = {};
					if(this.state.method === 'put'){
						inc.transfusional_control_id = start.id;
					}
					
					if(this.state.start_incidents.length > 0){
						if(this.state.start_incidents[0].incident.id !== undefined){
							inc.id = this.state.start_incidents[0].incident.id;
						}
						
						inc.observations = this.state.start_incidents[0].incident.observations;	

						inc.transfusional_incident_details = [];

						this.state.start_incidents[0].detail.map((d)=>{
							var det = {};

							if(this.state.method === 'put'){
								det.transfusional_control_id = start.id;
							}

							if(d.id !== undefined){
								det.id = d.id;
							}

							det.incident_id = d.incident_id;

							inc.transfusional_incident_details.push(det);
						});

						start.transfusional_incidents = [inc];
					}
					
				}

				obj.push(start);
			}

			if(this.state.valid_during){
				var during = {
					date: moment(this.state.during_date).format('YYYY-MM-DD') !== 'Invalid date' ?
						  	moment(this.state.during_date).format('YYYY-MM-DD') : "",
					hour: moment(this.state.during_hour, 'HH:mm').format('H:mm') !== 'Invalid date' ?
						 	moment(this.state.during_hour, 'HH:mm').format('H:mm') : "",
					medical_name: this.state.during_medical_name,
					sistiolica: this.state.during_sistiolica,
					diastiolica: this.state.during_diastiolica,
					pulse: this.state.during_pulse,
					temperature: this.state.during_temperature,
					unit_id:this.state.unit_id,
					type:this.state.during_type,
					heart_rate:this.state.during_heart_rate
				}
				if(this.state.during_id !== ""){
					during.id = this.state.during_id;
					during.timestamp = this.state.during_timestamp;
				}

				if(this.state.check_incident){
					inc = {};
					if(this.state.method === 'put'){
						inc.transfusional_control_id = during.id;
					}
					if(this.state.during_incidents.length > 0){
						if(this.state.during_incidents[0].incident.id){
							inc.id = this.state.during_incidents[0].incident.id;
						}
						
						inc.observations = this.state.during_incidents[0].incident.observations;
						inc.transfusional_incident_details = [];

						this.state.during_incidents[0].detail.map((d)=>{
							var det = {};

							if(this.state.method === 'put'){
								det.transfusional_control_id = during.id;
							}

							if(d.id !== undefined){
								det.id = d.id;
							}

							det.incident_id = d.incident_id;

							inc.transfusional_incident_details.push(det);
						})

						during.transfusional_incidents = [inc];
					}
						
				}


				obj.push(during);
			}


			if(this.state.valid_end){
				var end = {
					date: moment(this.state.end_date).format('YYYY-MM-DD') !== 'Invalid date' ?
						  	moment(this.state.end_date).format('YYYY-MM-DD') : "",
					hour: moment(this.state.end_hour, 'HH:mm').format('H:mm') !== 'Invalid date' ?
						 	moment(this.state.end_hour, 'HH:mm').format('H:mm') : "",
					medical_name: this.state.end_medical_name,
					sistiolica: this.state.end_sistiolica,
					diastiolica: this.state.end_diastiolica,
					pulse: this.state.end_pulse,
					temperature: this.state.end_temperature,
					unit_id:this.state.unit_id,
					type:this.state.end_type,
					heart_rate:this.state.end_heart_rate
				}
				if(this.state.end_id !== ""){
					end.id = this.state.end_id;
					end.timestamp = this.state.end_timestamp;
				}

				if(this.state.check_incident){
					inc = {};
					if(this.state.method === 'put'){
						inc.transfusional_control_id = end.id;
					}
					
					if(this.state.end_incidents.length > 0){
						if(this.state.end_incidents[0].incident.id !== undefined){
							inc.id = this.state.end_incidents[0].incident.id;
						}
						
						inc.observations = this.state.end_incidents[0].incident.observations;
						inc.transfusional_incident_details = [];

						this.state.end_incidents[0].detail.map((d)=>{
							var det = {};

							if(this.state.method === 'put'){
								det.transfusional_control_id = end.id;
							}

							if(d.id !== undefined){
								det.id = d.id;
							}

							det.incident_id = d.incident_id;

							inc.transfusional_incident_details.push(det);
						})

						end.transfusional_incidents = [inc];
					}
						
				}

				obj.push(end);
			}

			if(obj.length > 0){
				console.log(obj)
				
				fetch(Config.default.apiGateway.URL+'transfusional_control',{
					method:this.state.method,
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return 'ok';
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						//this.handleClose();
						this.props.history.push('/transfusional_control/list');
						swal('Correcto', 'Registro guardado correctamente', 'success');		
					}
				})
				
			}else{
				swal('Error', 'Campos Incompletos', 'error');
			}			
				
		}, 500);
	}

	saveType(){
		const select_start = document.querySelector('fieldset.start');
		const start = select_start.querySelectorAll('input');

		var valid_start = 0;
		start.forEach(function(s){
			if(s.value !== ""){
				valid_start++;
			}
			
		})	

		const select_during = document.querySelector('fieldset.during');
		const during = select_during.querySelectorAll('input');

		var valid_during = 0;
		during.forEach(function(s){
			if(s.value !== ""){
				valid_during++;
			}
			
		})		

		const select_end = document.querySelector('fieldset.end');
		const end = select_end.querySelectorAll('input');

		var valid_end = 0;
		end.forEach(function(s){
			if(s.value !== ""){
				valid_end++;
			}
			
		})
		if(valid_start > 0 ){
			this.setState({valid_start:true});
		}
		if(valid_during> 0){
			this.setState({valid_during:true});
		}
		if(valid_end > 0){
			this.setState({valid_end:true});
		}
	}

	changeScreen(screen){
		switch(screen){
			case 'start':
				this.props.waiting.handleShow('Cargando...');
				
				this.setState({
					enable_start:true,
					enable_during:false,
					enable_end:false,
				});

				this.loadIncidents(this.state.start_incidents);
				setTimeout(()=>{this.props.waiting.handleClose()},1000);
				break;
			case 'during':
				this.props.waiting.handleShow('Cargando...');
				this.setState({
					enable_start:false,
					enable_during:true,
					enable_end:false,
				});
				this.loadIncidents(this.state.during_incidents);
				setTimeout(()=>{this.props.waiting.handleClose()},1000);
				break;
			case 'end':
				this.props.waiting.handleShow('Cargando...');
				this.setState({
					enable_start:false,
					enable_during:false,
					enable_end:true,
				});
				this.loadIncidents(this.state.end_incidents);
				setTimeout(()=>{this.props.waiting.handleClose()},1000);
				break;
		}
	}

	checkIncident(e){
		var id_parent = parseInt(e.target.id.split('_')[1]);
		var id_child = parseInt(e.target.id.split('_')[2]);
		var check = e.target.checked;

		var detail = [], incident = {}

		this.state.incidents_type.map((inc, i)=>{
			if(id_parent === inc.id){
				this.state.list_incidents.map((list, j)=>{
					if(id_parent === list.parent.id){
						if(inc.key !== 'CLINICAL_MANIFESTATIONS' && inc.key !== 'INCIDENTS' &&
							inc.key !== 'TYPES_ERROR'){
							if(id_child !== list.lookup.id){
								document.getElementById('check_'+inc.id+'_'+list.lookup.id).checked = false
							}
						}
							
					}
				})
			}
		})

		this.state.incidents_type.map((inc, i)=>{
			this.state.list_incidents.map((list, j)=>{
				if(document.getElementById('check_'+inc.id+'_'+list.lookup.id) !== null){
					if(document.getElementById('check_'+inc.id+'_'+list.lookup.id).checked){
						detail.push({incident_id:list.lookup.id});
					}
				}
			})
		})

		if(this.state.enable_start){
			incident.observations = this.state.start_incidents.length > 0 ? this.state.start_incidents[0].incident.observations : this.state.observations;
		
			if(this.state.start_incidents.length > 0){
				if(this.state.start_incidents[0].incident.id !== undefined){
					incident.id = this.state.start_incidents[0].incident.id;
				}

				this.state.start_incidents[0].detail.map((d)=>{
					var i_s = detail.findIndex(obj => 
						obj.incident_id === d.incident_id
					)

					if(i_s !== -1){
						detail[i_s].id = d.id;
					}
				});
			}

			this.setState({start_incidents: [{incident:incident, detail:detail}]});
		}

		if(this.state.enable_during){
			incident.observations = this.state.during_incidents.length > 0 ? this.state.during_incidents[0].incident.observations : this.state.observations;
			
			if(this.state.during_incidents.length > 0){
				if(this.state.during_incidents[0].incident.id !== undefined){
					incident.id = this.state.during_incidents[0].incident.id;
				}

				this.state.during_incidents[0].detail.map((d)=>{
					var i_s = detail.findIndex(obj => 
						obj.incident_id === d.incident_id
					)

					if(i_s !== -1){
						detail[i_s].id = d.id;
					}
				});
			}
				
			this.setState({during_incidents: [{incident:incident, detail:detail}]});
		}

		if(this.state.enable_end){
			incident.observations = this.state.end_incidents.length > 0 ? this.state.end_incidents[0].incident.observations : this.state.observations;
			
			if(this.state.end_incidents.length > 0){
				if(this.state.end_incidents[0].incident.id !== undefined){
					incident.id = this.state.end_incidents[0].incident.id;
				}

				this.state.end_incidents[0].detail.map((d)=>{
					var i_s = detail.findIndex(obj => 
						obj.incident_id === d.incident_id
					)

					if(i_s !== -1){
						detail[i_s].id = d.id;
					}
				});
			}

				
			this.setState({end_incidents: [{incident:incident, detail:detail}]});
		}
	}

	regresar(){
		this.props.history.push('/transfusional_control/list');
	}

	loadIncidents(item){
		this.state.incidents_type.map((inc, i)=>{
			this.state.list_incidents.map((list, j)=>{
				if(document.getElementById('check_'+inc.id+'_'+list.lookup.id) !== null){
					document.getElementById('check_'+inc.id+'_'+list.lookup.id).checked = false
				}			
			})
			
		})
		this.setState({
			observations: item !== undefined && item.length > 0 ? item[0].incident.observations : "",
		});
		item.map((l, i)=>{
			l.detail.map((d, j)=>{
				this.state.incidents_type.map((inc, i)=>{
					this.state.list_incidents.map((list, j)=>{
						if(d.incident_id === list.lookup.id){
							if(document.getElementById('check_'+inc.id+'_'+list.lookup.id) !== null){
								document.getElementById('check_'+inc.id+'_'+list.lookup.id).checked = true
							}
						}				
					})
					
				})
			})
				
		})
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<h5 className="title_page" >
					Hemovigilancia -> 
					Listado
				</h5>
				
				<fieldset className="col-xs-12 form-group start" style={this.state.enable_start ? {display:'block'} : {display:'none'}}>
					<legend>Inicio Transfusión</legend>
					<div className="col-xs-12">
						<span className="span-min">Hospital:</span>
					</div>
					<div className="col-xs-12">
						<label>{this.state.hospital}</label>
					</div>
					<div className="col-xs-12">
						<span className="span-min">Paciente:</span>
					</div>
					<div className="col-xs-12 form-group">
						<label>{this.state.patient}</label>
					</div>

					<div className="col-xs-6">
						<span className="span-min">Fecha</span>
						<input type="date" className="form-control hour-input" value={this.state.start_date} 
							name="start_date" id="start_date" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Hora</span>
						<input type="time" className="form-control hour-input" value={this.state.start_hour} 
							name="start_hour" id="start_hour" onChange={this.handleChange} />
					</div>

					<div className="col-xs-12">
						<span className="span-min">Iniciada por:</span>
						<input type="text" className="form-control" value={this.state.start_medical_name} 
							name="start_medical_name" id="start_medical_name" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Sistiólica:</span>
						<input type="text" className="form-control" value={this.state.start_sistiolica} 
							name="start_sistiolica" id="start_sistiolica" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Diastiólica:</span>
						<input type="text" className="form-control" value={this.state.start_diastiolica} 
							name="start_diastiolica" id="start_diastiolica" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Pulso:</span>
						<input type="text" className="form-control" value={this.state.start_pulse} 
							name="start_pulse" id="start_pulse" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Temperatura:</span>
						<input type="text" className="form-control" value={this.state.start_temperature} 
							name="start_temperature" id="start_temperature" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Frecuencia Respiratoria:</span>
						<input type="text" className="form-control" value={this.state.start_heart_rate} 
							name="start_heart_rate" id="start_heart_rate" onChange={this.handleChange} />
					</div>
				</fieldset>

				<fieldset className="col-xs-12 form-group during" style={this.state.enable_during ? {display:'block'} : {display:'none'}}>
					<legend>Durante Transfusión</legend>
					<div className="col-xs-12">
						<span className="span-min">Hospital:</span>
					</div>
					<div className="col-xs-12">
						<label>{this.state.hospital}</label>
					</div>
					<div className="col-xs-12">
						<span className="span-min">Paciente:</span>
					</div>
					<div className="col-xs-12 form-group">
						<label>{this.state.patient}</label>
					</div>

					<div className="col-xs-6">
						<span className="span-min">Fecha</span>
						<input type="date" className="form-control hour-input" value={this.state.during_date} 
							name="during_date" id="during_date" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Hora</span>
						<input type="time" className="form-control hour-input" value={this.state.during_hour} 
							name="during_hour" id="during_hour" onChange={this.handleChange} />
					</div>

					<div className="col-xs-12">
						<span className="span-min">Iniciada por:</span>
						<input type="text" className="form-control" value={this.state.during_medical_name} 
							name="during_medical_name" id="during_medical_name" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Sistiólica:</span>
						<input type="text" className="form-control" value={this.state.during_sistiolica} 
							name="during_sistiolica" id="during_sistiolica" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Diastiólica:</span>
						<input type="text" className="form-control" value={this.state.during_diastiolica} 
							name="during_diastiolica" id="during_diastiolica" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Pulso:</span>
						<input type="text" className="form-control" value={this.state.during_pulse} 
							name="during_pulse" id="during_pulse" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Temperatura:</span>
						<input type="text" className="form-control" value={this.state.during_temperature} 
							name="during_temperature" id="during_temperature" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Frecuencia Respiratoria:</span>
						<input type="text" className="form-control" value={this.state.during_heart_rate} 
							name="during_heart_rate" id="during_heart_rate" onChange={this.handleChange} />
					</div>
				</fieldset>

				<fieldset className="col-xs-12 form-group end" style={this.state.enable_end ? {display:'block'} : {display:'none'}}>
					<legend>Fin Transfusión</legend>
					<div className="col-xs-12">
						<span className="span-min">Hospital:</span>
					</div>
					<div className="col-xs-12">
						<label>{this.state.hospital}</label>
					</div>
					<div className="col-xs-12">
						<span className="span-min">Paciente:</span>
					</div>
					<div className="col-xs-12 form-group">
						<label>{this.state.patient}</label>
					</div>

					<div className="col-xs-6">
						<span className="span-min">Fecha</span>
						<input type="date" className="form-control hour-input" value={this.state._end_date} 
							name="end_date" id="end_date" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Hora</span>
						<input type="time" className="form-control hour-input" value={this.state._end_hour} 
							name="end_hour" id="end_hour" onChange={this.handleChange} />
					</div>

					<div className="col-xs-12">
						<span className="span-min">Iniciada por:</span>
						<input type="text" className="form-control" value={this.state._end_medical_name} 
							name="end_medical_name" id="end_medical_name" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Sistiólica:</span>
						<input type="text" className="form-control" value={this.state._end_sistiolica} 
							name="end_sistiolica" id="end_sistiolica" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Diastiólica:</span>
						<input type="text" className="form-control" value={this.state._end_diastiolica} 
							name="end_diastiolica" id="end_diastiolica" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Pulso:</span>
						<input type="text" className="form-control" value={this.state._end_pulse} 
							name="end_pulse" id="end_pulse" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Temperatura:</span>
						<input type="text" className="form-control" value={this.state._end_temperature} 
							name="end_temperature" id="end_temperature" onChange={this.handleChange} />
					</div>
					<div className="col-xs-6">
						<span className="span-min">Frecuencia Respiratoria:</span>
						<input type="text" className="form-control" value={this.state.end_heart_rate} 
							name="end_heart_rate" id="end_heart_rate" onChange={this.handleChange} />
					</div>
				</fieldset>

				<hr style={{width:'100%'}} />
				<div className="col-xs-12 form-group" style={{textAlign:'center'}}>
						{!this.state.enable_start || this.state.enable_end?
							<div className="col-xs-6">
								<button className="btn btn-info"  style={{width:'100%'}}
									onClick={()=>this.changeScreen('start')}>
									Inicio Transfusión
								</button>
							</div>
						:null}
						
					
						{!this.state.enable_during || this.state.enable_end?
							<div className="col-xs-6">
								<button className="btn btn-info"  style={{width:'100%'}}
									onClick={()=>this.changeScreen('during')}>
									Durante Transfusión
								</button>
							</div>
						:null}
							
						{!this.state.enable_end || this.state.enable_during ?
							<div className="col-xs-6">
								<button className="btn btn-info"   style={{width:'100%'}}
									onClick={()=>this.changeScreen('end')}>
									Fin Transfusión
								</button>
							</div>
						:null}
				</div>


				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<input type="checkbox" name="check_incident" id="check_incident" value={this.state.check_incident}
							onChange={this.handleChange} checked={this.state.check_incident} style={{marginRight:'10px'}} />
						Incidentes
					</div>
					{/*this.state.check_incident ?
						<div className="col-xs-12 col-sm-2">
							<select className="form-control" name="incident_time" id="incident_time" value={this.state.incident_time}
								onChange={this.handleChange} >
								<option value="">Seleccione...</option>
								<option value="START">Inicio de Transfusión</option>
								<option value="DURING">Durante Transfusión</option>
								<option value="END">Despues de Transfusión</option>
							</select>
						</div>
					:null*/}
				</div>



				{this.state.check_incident ?
					<div>
						<div className="col-xs-12 form-group">
							<div className="col-xs-12">
								<span className="span-min">Observaciones</span>
								<textarea className="form-control" name="observations" id="observations" 
									style={{height:"50px",width:"100%",resize:"none"}}
		        					value={this.state.observations} onChange={this.handleChange} />
							</div>
						</div>
						<div className="col-xs-12">
							{this.state.incidents_type.map((inc, i)=>(
								<fieldset className="col-xs-12 col-sm-3" key={i}>
									<legend>{inc.value_name}</legend>
									{this.state.list_incidents.map((list, j)=>(
										inc.id === list.parent.id ?
											<div className="col-xs-12" key={j}>
												<input type="checkbox" id={'check_'+inc.id+'_'+list.lookup.id}
													onChange={this.checkIncident} style={{marginRight:'10px'}} /> 
												{list.lookup.value_name}
											</div>
										:null
											
									))}
								</fieldset>
							))}
						</div>
					</div>
				:null}

				<div className="col-xs-12">
					<div className="col-xs-12" style={{textAlign:'center'}}>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
		        			disabled={this.state.disabledFields} onClick={this.onSave}  style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} 
		        			onClick={this.handleClose} style={{margin:12}}/>
		        	</div>
				</div>
				
			</div>				
		)
			
	}
}

export default translate('translations') (TransfusionForm)